export default "__VITE_ASSET__CVqp44nu__"